import { render } from "./HexagonalBoard.vue?vue&type=template&id=70397e98&scoped=true"
import script from "./HexagonalBoard.vue?vue&type=script&lang=js"
export * from "./HexagonalBoard.vue?vue&type=script&lang=js"

import "./HexagonalBoard.vue?vue&type=style&index=0&id=70397e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70397e98"]])

export default __exports__